import Vue from 'vue';
import axios from 'axios';
import _ from 'lodash';
import FormData from './libs/form-data';
import UserAPI from './user';
import ResourceAPI from './libs/resource';
import UtilsAPI from './utils';

const baseURL = process.env.VUE_APP_API_URL;
const getOptions = () => {
    const token = localStorage.getItem('token');
    return {
        baseURL,
        headers: {
            ...token ? { authorization: `Bearer ${token}` } : {},
        },
    };
};

axios.interceptors.response.use((response) => response, (error) => {
    if (error.response?.status === 401) {
        localStorage.removeItem('token');
        Vue.prototype.$bus.$emit('updateToken', '');
        Vue.prototype.$bus.$emit('unauthorized');
    }
    return Promise.reject(error);
});

const API = {
    User: new UserAPI('user', getOptions),
    UserInfoResource: new ResourceAPI('user/info/resource', getOptions),
    Manager: new UserAPI('manager', getOptions),
    ManagerAccess: new ResourceAPI('manager/access', getOptions),
    ManagerAuthResource: new ResourceAPI('manager/auth/resource', getOptions),
    ManagerInfoResource: new ResourceAPI('manager/info/resource', getOptions),
    Clinic: new ResourceAPI('clinic', getOptions),
    Pool: new ResourceAPI('pool', getOptions),
    Question: new ResourceAPI('question', getOptions),
    Record: new ResourceAPI('record', getOptions),
    Tag: new ResourceAPI('tag', getOptions),
    Event: new ResourceAPI('event', getOptions),
    Setting: new ResourceAPI('setting', getOptions),
    Utils: UtilsAPI(getOptions),
    Static: (url) => (/^(blob|http)/.test(url) ? url : `${baseURL}${url}`),
    FormData,
};
const sdk = {
    async fetchConfig(version = 'default') {
        return API.Setting.PrivateFindResource({ version })
            .then((response) => response.data);
    },
    async loginWithLine(lineAccessToken) {
        // 第一次登入 回傳
        // todayNewLogin: true
        // 之後的登入 example
        // todayNewLogin: boolean
        // lastLogin: "2021-10-19T08:35:45.134Z"
        // loginDayCount: int
        return API.User.LineLogin(lineAccessToken).then((response) => response.data);
    },
    updateUserProfile({ name, phone, email }) {
        // response 不重要，會透過update token event更新個人檔案
        return API.User.UpdateInfo({ name, phone, email });
    },
    // 新加入群組請帶 name, password
    // 舊群組請帶 name
    changeGroup({ name, password }) {
        // response 不重要，會透過update token event更新個人檔案
        return API.User.changeGroup({ name, password });
    },
    leaveGroup() {
        return API.User.leaveGroup();
    },
    // game: 1, 2, level: 1, 2, 3
    async getQuestions(game, level) {
        const type = _.get({ 1: 'tf', 2: 'choice' }, game);
        const config = API.Pool.toConfig({ params: { level, type, game } });
        // response
        // all: 所有題目清單
        // - question: 題目
        // - options: 選項
        // - answer: 答案選項index(是非題answer 1答案等於是, 0答案等於否)
        // answerCorrected: 過去答對過的題目id array
        // highestScore: 過往的歷史最高分
        const isLogin = !!config.headers.authorization;
        const url = isLogin
            ? '/api/question/fetchGame'
            : '/api/question/fetchGameGuest';
        return axios.get(url, config).then((response) => response.data);
    },
    async getEventQuestions(eventId, game, level) {
        const type = _.get({ 1: 'tf', 2: 'choice' }, game);
        const config = API.Pool.toConfig({ params: { level, type, game } });
        const url = `/api/event-question/${eventId}/fetchGame`;
        return axios.get(url, config).then((response) => response.data);
    },
    submitResult({
        game, level, right, wrong, highestScore, score, trophy,
    }) {
        const params = {
            game,
            level,
            right, // array of string 本次答對的題目ID們
            wrong, // array of string 本次答錯的題目ID們
            highestScore,
            score, // 這次遊戲的分數
            trophy,
        };
        // response 不重要
        return axios.post('/api/record/update', params, API.Record.toConfig());
    },
    submitEventResult({
        event, game, level, right, wrong, score, answerTime,
    }) {
        const params = {
            game,
            level,
            right, // array of string 本次答對的題目ID們
            wrong, // array of string 本次答錯的題目ID們
            score,
            answerTime,
        };
        // 這隻api也有送排行榜資訊
        return axios.post(`/api/event-stat/${event}/update`, params, getOptions());
    },
    submitComicResult({ level, records }) {
        return API.User.submitComicResult({ level, records });
    },
    getRecords() {
        return API.Record.PrivateList(API.Record.toConfig())
            .then((response) => response.data.raw);
    },
    joinEvent({ eventId, code, name }) {
        return API.User.joinEvent({ id: eventId, code, name });
    },
    leaveEvent() {
        return API.User.leaveEvent();
    },
};
export default {
    ...sdk,
    async test() {
        // console.log('test');
        // sdk.changeGroup({ name: '維肯' });
        // sdk.leaveGroup();
        // sdk.getQuestions(1, 1).then(console.log);
        // await sdk.submitResult({
        //     game: 1,
        //     level: 1,
        //     right: ['615fe87b3a60971b2ec22e07'],
        //     wrong: ['615fe87b3a60971b2ec22e07'],
        //     highestScore: 10,
        //     score: 10,
        //     trophy: 1,
        // });
        // sdk.getRecords().then(console.log);
    },
};
